import { ContentAiIcon } from '@app/modules/content-ai/ContentAiIcon';
import { FragmentIcon } from '@app/modules/fragments/components/FragmentIcon';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import { Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { AlertIcon } from '../../alerts/AlertIcon';
import { DashboardItem } from '../DashboardItem';
import { AdminSection } from '../Section';

export function FeatureConfigurationSection() {
  return (
    <AdminSection
      title={
        <FormattedMessage
          id="admin.dashboard.featureConfigurationTitle"
          defaultMessage="Configuración de features"
        />
      }
    >
      <Grid container spacing={2}>
        <DashboardItem
          icon={<AlertIcon />}
          title={<FormattedMessage id="admin.dashboard.alertsTitle" defaultMessage="Alertas" />}
          content={
            <FormattedMessage
              id="admin.dashboard.alertsBody"
              defaultMessage="Configurar notificaciones de monitoreo"
            />
          }
          actions={[
            {
              to: '/admin/alerts',
              text: (
                <FormattedMessage id="admin.dashboard.alertsBtnText" defaultMessage="Configurar" />
              ),
              className: 'btn-manage-alerts',
              dataCy: 'manage-alerts',
            },
          ]}
        />

        <DashboardItem
          icon={<FragmentIcon />}
          title={<FormattedMessage id="admin.dashboard.fragments" defaultMessage="Fragmentos" />}
          content={
            <FormattedMessage
              id="admin.dashboard.fragmentsBody"
              defaultMessage="Administrar configuración de fragmentos"
            />
          }
          actions={[
            {
              to: '/admin/fragments',
              text: (
                <FormattedMessage
                  id="admin.dashboard.fragmentsBtnText"
                  defaultMessage="Configurar"
                />
              ),
              className: 'btn-manage-fragments',
              dataCy: 'manage-fragments',
            },
          ]}
        />

        <DashboardItem
          icon={<ContentAiIcon />}
          title={<FormattedMessage id="contentAi.title" defaultMessage="Content AI" />}
          content={
            <FormattedMessage
              id="admin.dashboard.contentAiBody"
              defaultMessage="Administrar configuración de Content AI"
            />
          }
          actions={[
            {
              to: '/admin/content-ai',
              text: (
                <FormattedMessage
                  id="admin.dashboard.contentAiBtnText"
                  defaultMessage="Configurar"
                />
              ),
            },
          ]}
        />

        <DashboardItem
          icon={<PersonalVideoIcon />}
          title={
            <FormattedMessage
              id="admin.dashboard.videoAnalysisTitle"
              defaultMessage="Análisis de Video"
            />
          }
          content={
            <FormattedMessage
              id="admin.dashboard.videoAnalysisBody"
              defaultMessage="Configurar análisis automático de video"
            />
          }
          actions={[
            {
              to: '/admin/video-analysis',
              text: (
                <FormattedMessage
                  id="admin.dashboard.videoAnalysisBtnText"
                  defaultMessage="Configurar"
                />
              ),
              className: 'btn-manage-video-analysis',
              dataCy: 'manage-video-analysis',
            },
          ]}
        />
      </Grid>
    </AdminSection>
  );
}
